<div class="dds-modal-overlay" (click)="closeArchiveModel()"></div>

<div ddsResize class="dds-modal padding-left-right-0">
  <div class="dds-modal__header padding-left-right-24">
    <span *ngIf="!initialSelectedArchive" class="dds-modal__title"
      >Select archive</span
    >
    <span *ngIf="initialSelectedArchive" class="dds-modal__title"
      >Change archive</span
    >
    <dds-button
      size="sm"
      icon="dds-icon_close"
      kind="silent"
      theme="dark"
      ariaLabel="Close modal"
      class="dds-modal__close"
      (clicked)="closeArchiveModel()"
    ></dds-button>
  </div>

  <div class="dds-modal__body padding-left-right-24">
    <span class="eclipse-small-header-grey">Charge Code (WBS):</span>
    <dds-suggestions-tags-input
      [(ngModel)]="wbsChargeCode"
      [ariaLabel]="'Archive'"
      [placeholder]="'Search for WBS'"
      [searchList]="searchList"
      [isOpenPopupOnFocus]="true"
      [isLoading]="isFetchingWBS"
      [optionsTemplate]="wbsStickerTemplate"
      (ngModelChange)="changeValue()"
    >
    </dds-suggestions-tags-input>

    <div *ngIf="wbsChargeCode" class="padding-none margin-top-s">
      <span class="eclipse-small-header-grey">WBS Description</span>
      <p class="padding-none">{{ wbsDescription }}</p>
    </div>
    <div class="margin-top-s">
      <span class="eclipse-small-header-grey">Archive:</span>
      <dds-select
        [placeholder]="'Search'"
        [list]="actionDropdownList"
        [(ngModel)]="selectedArchive"
        (ngModelChange)="archiveChanged()"
      ></dds-select>
    </div>
  </div>
  <ng-template #wbsStickerTemplate>
    <div class="wbs-custom-options-sticker" (scroll)="onWBSScroll($event)">
      <div
        class="context-menu-item"
        *ngFor="let item of searchList; let index = index"
        (click)="wbsChargeCode = item; changeValue()"
      >
        {{ item }}
      </div>
    </div>
  </ng-template>
  <div
    class="dds-modal__footer horizontal-divider padding-left-right-24"
    *ngIf="isFooter"
  >
    <div class="dds-modal__footer-content dds-modal__footer-content_left">
      <dds-button
        class="dds-modal__footer-item"
        (clicked)="open()"
        (keyboardClicked)="open()"
        [disabled]="isSaveButtonDisabled"
        >Save</dds-button
      >
      <dds-button
        class="dds-modal__footer-item"
        kind="secondaryLoud"
        (clicked)="closeArchiveModel()"
        (keyboardClicked)="closeArchiveModel()"
        >Close</dds-button
      >
    </div>
  </div>
</div>
